(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-arrival-window"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-arrival-window')) {
    class GgArrivalWindow extends HTMLElement {
      static holidays = new Set([
        '2026-01-01', '2026-01-02', '2026-03-17', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-06-15', '2026-07-13', '2026-08-03', '2026-08-31', '2026-11-30', '2026-12-25', '2026-12-28',
        '2027-01-01', '2027-01-04', '2027-03-17', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-07-12', '2027-08-02', '2027-08-30', '2027-11-30', '2027-12-27', '2027-12-28',
        '2028-01-03', '2028-01-04', '2028-03-17', '2028-04-14', '2028-04-17', '2028-05-01', '2028-05-29', '2028-07-12', '2028-08-07', '2028-08-28', '2028-11-30', '2028-12-25', '2028-12-26'
      ]);
      static clock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' });
      static key(date) { return date.toISOString().slice(0, 10); }
      static working(date) { return ![0, 6].includes(date.getUTCDay()) && !this.holidays.has(this.key(date)); }
      static advance(date, days) {
        const result = new Date(date);
        for (let count = 0; count < days;) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (this.working(result)) count += 1;
        }
        return result;
      }
      static range(timestamp, min, max) {
        if (![min, max].every(value => Number.isInteger(value) && value >= 1 && value <= 30) || min > max) return null;
        const parts = Object.fromEntries(this.clock.formatToParts(timestamp).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
        const order = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
        if (parts.hour >= 23) order.setUTCDate(order.getUTCDate() + 1);
        const start = this.advance(order, min);
        const end = this.advance(order, max);
        if (this.key(order) < '2026-01-01' || this.key(end) > '2028-12-31') return null;
        return { start, end };
      }
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.root = this.closest('.shopify-section');
        this.root?.addEventListener('variant:selected', () => { this.pending = true; this.hidden = true; }, options);
        this.root?.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const incoming = event.detail.data.html?.querySelector(`gg-arrival-window[data-product-id="${this.dataset.productId}"]`);
          this.dataset.eligible = incoming?.dataset.eligible || 'false';
          this.pending = false;
          this.tick();
        }, options);
        document.addEventListener('visibilitychange', () => this.tick(), options);
        this.tick();
        this.interval = window.setInterval(() => { if (!document.hidden) this.tick(); }, 60000);
      }
      disconnectedCallback() { this.controller?.abort(); window.clearInterval(this.interval); }
      tick() {
        this.hidden = !!this.pending || this.dataset.eligible !== 'true';
        if (this.hidden) return;
        const range = GgArrivalWindow.range(Date.now(), Number(this.dataset.min), Number(this.dataset.max));
        const dates = this.querySelector('[data-arrival-dates]');
        if (!range) { dates.textContent = this.dataset.fallback; return; }
        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short' });
        dates.textContent = `${format.format(range.start)} – ${format.format(range.end)}`;
      }
    }
    customElements.define('gg-arrival-window', GgArrivalWindow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-cart-change"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-cart-change')) {
    customElements.define('gg-cart-change', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.querySelector('form')?.addEventListener('submit', event => this.change(event), { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async request(path, body) {
        const response = await fetch(this.dataset.root + path, {
          credentials: 'same-origin', cache: 'no-store',
          ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {})
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(this.dataset.error);
        return data;
      }
      async change(event) {
        event.preventDefault();
        const selected = this.querySelector('select').value;
        if (selected === this.dataset.variant || this.busy) return;
        const section = this.closest('.gg-cart');
        if (section.dataset.updating === 'true') return;
        this.busy = true;
        section.dataset.updating = 'true';
        const status = this.querySelector('[data-change-status]');
        status.textContent = this.dataset.updating;
        section.querySelectorAll('button,input,select,textarea').forEach(element => { element.disabled = true; });
        section.querySelector('[data-gg-express]')?.setAttribute('inert', '');
        try {
          const before = await this.request('cart.js');
          const source = before.items.find(item => item.key === this.dataset.key);
          if (!source || source.quantity !== Number(this.dataset.quantity) || Object.keys(source.properties || {}).length || source.selling_plan_allocation) throw new Error(this.dataset.changed);
          const targets = before.items.filter(item => String(item.variant_id) === selected);
          if (targets.some(item => Object.keys(item.properties || {}).length || item.selling_plan_allocation)) throw new Error(this.dataset.error);
          const targetBefore = targets.reduce((sum,item) => sum + item.quantity, 0);
          await this.request('cart/add.js', { items: [{ id: Number(selected), quantity: source.quantity }] });
          const added = await this.request('cart.js');
          const targetAfter = added.items.filter(item => String(item.variant_id) === selected).reduce((sum,item) => sum + item.quantity, 0);
          const remaining = added.items.filter(item => String(item.variant_id) === this.dataset.variant && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation);
          if (targetAfter !== targetBefore + source.quantity || remaining.length !== 1 || remaining[0].quantity !== source.quantity) throw new Error(this.dataset.error);
          await this.request('cart/change.js', { id: remaining[0].key, quantity: 0 });
          window.location.assign(this.dataset.root + 'cart');
        } catch (error) {
          status.textContent = error.message === this.dataset.changed ? this.dataset.changed : this.dataset.error;
          this.querySelector('[data-change-review]').hidden = false;
          this.querySelector('[data-change-review]').focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-cart-gifts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-cart-gifts')) {
    customElements.define('gg-cart-gifts', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.express = this.closest('.gg-cart')?.querySelector('[data-gg-express]');
        this.checkout = this.closest('.gg-cart')?.querySelector('button[name="checkout"]');
        this.form.addEventListener('input', () => {
          this.dirty = true;
          if (this.express) this.express.hidden = true;
          if (this.checkout) this.checkout.disabled = true;
        }, { signal: this.controller.signal });
        this.form.addEventListener('change', () => this.save(), { signal: this.controller.signal });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.save(); }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async save() {
        if (this.busy) { this.again = true; return; }
        if (this.closest('.gg-cart')?.dataset.updating === 'true') return;
        this.busy = true;
        const status = this.querySelector('[data-gift-status]');
        status.textContent = this.dataset.pending;
        const attributes = { 'Gift receipt': this.querySelector('input[type="checkbox"]').checked ? 'Yes' : 'No', 'Gift message': this.querySelector('textarea').value };
        try {
          const response = await fetch(this.dataset.url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
          if (!response.ok) throw new Error();
          const cart = await response.json();
          if (cart.attributes['Gift receipt'] !== attributes['Gift receipt'] || (cart.attributes['Gift message'] || '') !== attributes['Gift message']) throw new Error();
          const same = this.querySelector('textarea').value === attributes['Gift message'] && (this.querySelector('input[type="checkbox"]').checked ? 'Yes' : 'No') === attributes['Gift receipt'];
          this.dirty = !same;
          status.textContent = same ? this.dataset.saved : this.dataset.pending;
          const cartLocked = this.closest('.gg-cart')?.dataset.updating === 'true';
          if (this.express) this.express.hidden = !same || cartLocked;
          if (this.checkout) this.checkout.disabled = !same || cartLocked;
          if (!same) this.again = true;
        } catch {
          status.textContent = this.dataset.error;
          if (this.express) this.express.hidden = true;
          if (this.checkout) this.checkout.disabled = true;
        } finally {
          this.busy = false;
          if (this.again) { this.again = false; this.save(); }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-dispatch-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-dispatch-countdown')) {
    class GgDispatchCountdown extends HTMLElement {
      static formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });

      static parts(timestamp) {
        return Object.fromEntries(this.formatter.formatToParts(timestamp)
          .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
      }

      static state(timestamp) {
        const local = this.parts(timestamp);
        const desired = Date.UTC(local.year, local.month - 1, local.day, 23);
        let deadline = desired;
        for (let attempt = 0; attempt < 3; attempt += 1) {
          const at = this.parts(deadline);
          deadline += desired - Date.UTC(at.year, at.month - 1, at.day, at.hour, at.minute, at.second);
        }
        return { closed: timestamp >= deadline, seconds: Math.max(0, Math.ceil((deadline - timestamp) / 1000)) };
      }

      connectedCallback() {
        this.message = this.querySelector('[data-dispatch-message]');
        this.clock = this.querySelector('[data-dispatch-clock]');
        if (!this.message || !this.clock) return;
        this.tick();
        this.interval = window.setInterval(() => { if (!document.hidden) this.tick(); }, 1000);
        this.onVisibility = () => this.tick();
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        window.clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      tick() {
        const state = GgDispatchCountdown.state(Date.now());
        this.message.textContent = state.closed ? this.dataset.closed : this.dataset.open;
        this.clock.hidden = state.closed;
        if (!state.closed) {
          this.clock.textContent = [Math.floor(state.seconds / 3600), Math.floor(state.seconds % 3600 / 60), state.seconds % 60]
            .map(value => String(value).padStart(2, '0')).join(':');
        }
      }
    }
    customElements.define('gg-dispatch-countdown', GgDispatchCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-mobile-purchase')) {
    customElements.define('gg-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section');
        this.form = this.root?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
        this.picker = this.root?.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        this.action = this.querySelector('[data-purchase-action]');
        this.price = this.querySelector('[data-purchase-price]');
        this.selection = this.querySelector('[data-purchase-selection]');
        if (!this.form || !this.nativeButton || !this.action || !this.price || !this.selection) return;
        this.confirmed = this.dataset.defaultVariant === 'true';
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.pending = false;
        this.root.dataset.ggChoiceRequired = String(!this.confirmed);
        this.form.addEventListener('submit', event => {
          if (this.confirmed) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.scrollTo(this.picker || this.form);
        }, { ...options, capture: true });
        this.root.addEventListener('click', event => {
          if (this.confirmed || !event.target.closest('button[ref="addToCartButton"]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.scrollTo(this.picker || this.form);
        }, { ...options, capture: true });
        this.action.addEventListener('click', () => this.purchase(), options);
        this.root.addEventListener('click', event => this.confirmChoice(event), options);
        this.root.addEventListener('change', event => this.confirmChoice(event), options);
        this.root.addEventListener('variant:selected', event => {
          if (event.target !== this.picker) return;
          this.pending = true;
          this.sync();
        }, options);
        this.root.addEventListener('variant:update', event => {
          if (String(event.detail.data.productId) !== this.dataset.productId) return;
          const incoming = event.detail.data.html.querySelector(`gg-mobile-purchase[data-product-id="${this.dataset.productId}"]`);
          if (incoming) {
            this.dataset.price = incoming.dataset.price;
            this.dataset.variantTitle = incoming.dataset.variantTitle;
            this.dataset.variantId = incoming.dataset.variantId;
          }
          this.pending = false;
          queueMicrotask(() => this.sync());
        }, options);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.visibility(); });
        };
        window.addEventListener('scroll', this.onScroll, { ...options, passive: true });
        window.addEventListener('resize', this.onScroll, options);
        document.addEventListener('cart:error', () => {
          if (this.usedShortcut) { this.usedShortcut = false; this.scrollTo(this.form); }
        }, options);
        document.addEventListener('cart:update', () => { this.usedShortcut = false; }, options);
        this.dataset.ready = 'true';
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      get nativeButton() { return this.form?.querySelector('button[ref="addToCartButton"]'); }

      confirmChoice(event) {
        const input = event.target.closest('input[type="radio"], select');
        if (!input || input.closest('variant-picker') !== this.picker) return;
        const option = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
        const position = Number(option?.dataset.inputId?.split('-')[0]);
        if (Number(this.dataset.sizePosition) === 0 || position === Number(this.dataset.sizePosition)) this.confirmed = true;
        queueMicrotask(() => this.sync());
      }

      scrollTo(element) {
        element?.scrollIntoView({ block: 'center', behavior: 'instant' });
        element?.querySelector('input:not([type="hidden"]):not(:disabled), select, button:not(:disabled)')?.focus({ preventScroll: true });
      }

      purchase() {
        if (!this.confirmed) { this.scrollTo(this.picker || this.form); return; }
        if (this.pending || !this.nativeButton || this.nativeButton.disabled) return;
        if (this.form.querySelector('[name="id"]')?.value !== this.dataset.variantId) { this.scrollTo(this.form); return; }
        this.usedShortcut = true;
        this.nativeButton.click();
        queueMicrotask(() => {
          const error = this.form.querySelector('[ref="addToCartTextError"]:not(.hidden)');
          if (error) { this.usedShortcut = false; this.scrollTo(this.form); }
        });
      }

      sync() {
        const native = this.nativeButton;
        this.root.dataset.ggChoiceRequired = String(!this.confirmed);
        this.root.querySelectorAll('.accelerated-checkout-block').forEach(element => { element.inert = !this.confirmed; });
        const buttonText = native?.querySelector('.add-to-cart-text__content');
        if (!this.confirmed && buttonText && !native.disabled && buttonText.textContent.trim() !== this.dataset.choose) buttonText.textContent = this.dataset.choose;
        if (this.confirmed && buttonText?.textContent.trim() === this.dataset.choose && !native.disabled) buttonText.textContent = this.dataset.add;
        this.price.textContent = this.dataset.price;
        this.selection.textContent = this.confirmed ? this.dataset.variantTitle : this.dataset.choose;
        this.action.textContent = this.pending ? this.dataset.updating : !this.confirmed ? this.dataset.choose : native?.disabled ? this.dataset.unavailable : this.dataset.add;
        this.action.disabled = this.pending || (this.confirmed && (!native || native.disabled));
        this.visibility();
      }

      visibility() {
        const native = this.nativeButton;
        const rect = native?.getBoundingClientRect();
        this.hidden = !native || (rect.bottom >= 0 && rect.top < window.innerHeight) || window.innerWidth > 749;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-set-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-set-builder')) {
    class GgSetBuilder extends HTMLElement {
      static adding = false;

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.selects = [...this.querySelectorAll('[data-set-size]')];
        this.button = this.querySelector('[data-set-add]');
        this.status = this.querySelector('[data-set-status]');
        this.basketLink = this.querySelector('[data-set-basket]');
        if (!this.form || this.selects.length !== 2 || !this.button) return;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency', currency: this.dataset.currency || 'GBP'
        });
        this.querySelector('[data-set-purchase]').hidden = false;
        this.form.addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
        this.form.addEventListener('change', () => {
          if (!this.uncertain) {
            this.added = false;
            this.status.textContent = '';
            this.basketLink.hidden = true;
          }
          this.sync();
        }, { signal: this.controller.signal });
        this.sync();
      }

      disconnectedCallback() { this.controller?.abort(); }

      selected() {
        return this.selects.map(select => [...select.options].find(option => option.value === select.value && option.value && !option.hasAttribute('disabled')));
      }

      sync() {
        const choices = this.selected();
        const complete = choices.every(Boolean);
        this.querySelector('[data-set-total]').textContent = complete
          ? this.money.format(choices.reduce((sum, option) => sum + Number(option.dataset.price), 0) / 100)
          : this.dataset.choose;
        this.selects.forEach((select, index) => {
          if (choices[index]) select.closest('.gg-set__piece').querySelector('[data-piece-price]').textContent = choices[index].dataset.money;
          select.disabled = !!this.busy;
        });
        this.button.disabled = !!this.busy || (!complete && !this.uncertain && !this.added);
        this.button.textContent = this.busy ? this.dataset.adding : this.uncertain || this.added ? this.dataset.review : this.dataset.add;
        this.form.setAttribute('aria-busy', String(!!this.busy));
      }

      async request(url, options = {}) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
          const data = await response.json();
          return { ok: response.ok, data };
        } finally { window.clearTimeout(timeout); }
      }

      async add(event) {
        event.preventDefault();
        if (this.busy || GgSetBuilder.adding) return;
        if (this.uncertain || this.added) { window.location.assign(this.dataset.cartUrl); return; }
        const choices = this.selected();
        if (!choices.every(Boolean)) { this.form.reportValidity(); return; }
        const items = choices.map(option => ({ id: Number(option.value), quantity: 1 }));
        if (items[0].id === items[1].id) return;
        this.busy = true;
        GgSetBuilder.adding = true;
        this.status.textContent = '';
        this.sync();
        const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
        const payload = { items };
        if (sectionIds.length) { payload.sections = sectionIds; payload.sections_url = window.location.pathname + window.location.search; }
        try {
          const result = await this.request(this.dataset.addUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload)
          });
          if (!result.ok || result.data.status || !Array.isArray(result.data.items)) throw new Error('Unconfirmed basket');
          if (!items.every(item => result.data.items.some(line => Number(line.variant_id || line.id) === item.id && line.quantity >= 1))) throw new Error('Incomplete set');
          this.added = true;
          this.status.textContent = this.dataset.success;
          this.basketLink.hidden = false;
          const drawer = document.querySelector('cart-drawer-component');
          const usableSections = sectionIds.length && sectionIds.every(id => typeof result.data.sections?.[id] === 'string' && result.data.sections[id].trim());
          if (!drawer || !customElements.get('cart-drawer-component') || !customElements.get('cart-items-component') || !usableSections) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          try {
            const current = await this.request(this.dataset.cartUrl + '.js');
            if (!current.ok || !Number.isInteger(current.data.item_count)) throw new Error('Basket unavailable');
            this.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: current.data, sourceId: this.id, data: { source: 'gg-set-builder', itemCount: current.data.item_count, sections: result.data.sections } }
            }));
          } catch { window.location.assign(this.dataset.cartUrl); }
        } catch {
          this.uncertain = true;
          this.status.textContent = this.dataset.error;
          this.basketLink.hidden = false;
          this.status.focus();
        } finally {
          this.busy = false;
          GgSetBuilder.adding = false;
          this.sync();
        }
      }
    }
    customElements.define('gg-set-builder', GgSetBuilder);
  }
  } catch(e) { console.error(e); }
})();

})();
